<template>
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.3333 3.7002H4.66667C3.19391 3.7002 2 4.8941 2 6.36686V12.5891C2 14.0618 3.19391 15.2558 4.66667 15.2558H6.44444L10 17.9224V15.2558H15.3333C16.8061 15.2558 18 14.0618 18 12.5891V6.36686C18 4.8941 16.8061 3.7002 15.3333 3.7002Z"
      stroke="#747474" stroke-width="1.5" />
  </svg>
</template>
